import React from "react";
import "./ourhome.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Magentaimages from "./magenta.js";
import Oliveimages from "./olive.js";
import Mulberryimages from "./mulberry.js";
import Morizenimages from "./morizen.js";
import Burgundyimages from "./burgundy.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMaximize } from "@fortawesome/free-solid-svg-icons";
import { faHouse } from "@fortawesome/free-solid-svg-icons";
import { faBed } from "@fortawesome/free-solid-svg-icons";
import { faShower } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import vanicaimages from "./vanica.js";
import violaimages from "../../../media/Viola 8/index.js";
import jasmiaimages from "../../../media/Jasmia/index.js";
import cheliaimages from "../../../media/chelia/chelia.js";

const magenta = () => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const magentawa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6289510613901&text=Halo+della%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(magenta)%20https://marketingsummabekasi.id/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  const olivewa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6289510613901&text=Halo+della%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(Olive)%20https://marketingsummabekasi.id/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  const mulberrywa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6289510613901&text=Halo+della%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(Mulberry)%20https://marketingsummabekasi.id/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  const burgundywa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6289510613901&text=Halo+della%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(Burgundy)%20https://marketingsummabekasi.id/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  const morizenwa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6289510613901&text=Halo+della%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(Morizen)%20https://marketingsummabekasi.id/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  // const violawa = () => {
  //   const whatsappLink =
  //     "https://api.whatsapp.com/send/?phone=6289510613901&text=Halo+della%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(Viola)%20https://marketingsummabekasi.id/&type=phone_number&app_absent=0";
  //   window.location.href = whatsappLink;
  // };
  // const cheliawa = () => {
  //   const whatsappLink =
  //     "https://api.whatsapp.com/send/?phone=6289510613901&text=Halo+della%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(Viola)%20https://marketingsummabekasi.id/&type=phone_number&app_absent=0";
  //   window.location.href = whatsappLink;
  // };
  // const vanicawa = () => {
  //   const whatsappLink =
  //     "https://api.whatsapp.com/send/?phone=6289510613901&text=Halo+della%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(vanica)%20https://marketingsummabekasi.id/&type=phone_number&app_absent=0";
  //   window.location.href = whatsappLink;
  // };
  // const jasmiawa = () => {
  //   const whatsappLink =
  //     "https://api.whatsapp.com/send/?phone=6289510613901&text=Halo+della%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(jasmia)%20https://marketingsummabekasi.id/&type=phone_number&app_absent=0";
  //   window.location.href = whatsappLink;
  // };

  return (
    <div className="container-magenta">
      <div className="judul-magenta">
        <h1>OUR HOME</h1>
      </div>
      <div className="container-card">
        <div className="kartu">
          <Slider {...settings}>
            {Magentaimages.map((image, index) => (
              <img
                className="kartugambar"
                key={index}
                src={image}
                alt={`Astha ${index + 1}`}
              />
            ))}
          </Slider>
          <div className="container-title-card">
            <div className="titlecard">
              <div className="judul-rumah">Magenta Residence</div>
              <div className="sub-judul-rumah">Siap Huni</div>
              {/* <div className="cicilan">
                <div className="angka">10 Juta/Bulan</div>
              </div> */}
            </div>
          </div>
          <hr color="black" />
          <div className="deskripsi-cluster">
            <div className="deskripsi">
              Magenta Residence menawarkan hunian 2 lantai bertema modern dengan
              tiga pilihan tipe: Iris (5×11), Lilac (6×11), dan Plum (7×11).
            </div>
          </div>
          {/* <hr color="black" /> */}
          {/* <div className="gridspek">
            <FontAwesomeIcon icon={faMaximize} />
            <span> : 77m²</span>
            <FontAwesomeIcon icon={faHouse} />
            <span> : 95m²</span>
            <FontAwesomeIcon icon={faBed} />
            <span>: 4+1</span>
            <FontAwesomeIcon icon={faShower} />
            <span>: 3+1</span>
          </div> */}
          <div className="containerwhatsapp">
            <button onClick={magentawa} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
        {/* <div className="kartu">
          <Slider {...settings}>
            {cheliaimages.map((image, index) => (
              <img
                className="kartugambar"
                key={index}
                src={image}
                alt={`Astha ${index + 1}`}
              />
            ))}
          </Slider>
          <div className="container-title-card">
            <div className="titlecard">
              <div className="judul-rumah">Chelia</div>
              <div className="sub-judul-rumah">Free Voucher Jutaan Rupiah</div>
              <div className="cicilan">
                <div className="angka">5 Juta/Bulan</div>
              </div>
            </div>
          </div>
          <hr color="black" />
          <div className="gridspek">
            <FontAwesomeIcon icon={faMaximize} />
            <span> : 60m²</span>
            <FontAwesomeIcon icon={faHouse} />
            <span> : 73m²</span>
            <FontAwesomeIcon icon={faBed} />
            <span>: 2</span>
            <FontAwesomeIcon icon={faShower} />
            <span>: 2</span>
          </div>
          <div className="containerwhatsapp">
            <button onClick={cheliawa} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div> */}
        {/* <div className="kartu">
          <Slider {...settings}>
            {violaimages.map((image, index) => (
              <img
                className="kartugambar"
                key={index}
                src={image}
                alt={`Astha ${index + 1}`}
              />
            ))}
          </Slider>
          <div className="container-title-card">
            <div className="titlecard">
              <div className="judul-rumah">Viola</div>
              <div className="sub-judul-rumah">Siap Huni</div>
              <div className="cicilan">
                <div className="angka">9 Juta/Bulan</div>
              </div>
            </div>
          </div>
          <hr color="black" />
          <div className="gridspek">
            <FontAwesomeIcon icon={faMaximize} />
            <span> : 66m²</span>
            <FontAwesomeIcon icon={faHouse} />
            <span> : 114m²</span>
            <FontAwesomeIcon icon={faBed} />
            <span>: 3+1</span>
            <FontAwesomeIcon icon={faShower} />
            <span>: 2+1</span>
          </div>
          <div className="containerwhatsapp">
            <button onClick={violawa} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div> */}
        <div className="kartu">
          <Slider {...settings}>
            {Oliveimages.map((image, index) => (
              <img
                className="kartugambar"
                key={index}
                src={image}
                alt={`Astha ${index + 1}`}
              />
            ))}
          </Slider>
          <div className="container-title-card">
            <div className="titlecard">
              <div className="judul-rumah">Olive Residence</div>
              <div className="sub-judul-rumah">Siap Huni</div>
              {/* <div className="cicilan">
                <div className="angka">13 Juta/Bulan</div>
              </div> */}
            </div>
          </div>
          <hr color="black" />
          <div className="deskripsi-cluster">
            <div className="deskripsi">
              Olive Residence menyediakan empat opsi tipe rumah—Lime (5×11),
              Fern (6×11), Pine (7×11), dan Sage (7×12)—dengan desain tropis
              kontemporer.
            </div>
          </div>
          {/* <hr color="black" />
          <div className="gridspek">
            <FontAwesomeIcon icon={faMaximize} />
            <span> : 77m²</span>
            <FontAwesomeIcon icon={faHouse} />
            <span> : 83m²</span>
            <FontAwesomeIcon icon={faBed} />
            <span>: 3+1</span>
            <FontAwesomeIcon icon={faShower} />
            <span>: 3+1</span>
          </div> */}
          <div className="containerwhatsapp">
            <button onClick={olivewa} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
        <div className="kartu">
          <Slider {...settings}>
            {Mulberryimages.map((image, index) => (
              <img
                className="kartugambar"
                key={index}
                src={image}
                alt={`Astha ${index + 1}`}
              />
            ))}
          </Slider>
          <div className="container-title-card">
            <div className="titlecard">
              <div className="judul-rumah">Mulberry Residence</div>
              <div className="sub-judul-rumah">Siap Huni</div>
              {/* <div className="cicilan">
                <div className="angka">19 Juta/Bulan</div>
              </div> */}
            </div>
          </div>
          <hr color="black" />
          <div className="deskripsi-cluster">
            <div className="deskripsi">
              Mulberry Residence mengusung konsep “modern tropical” berbasis
              smart home technology, dengan tiga tipe unit: Cherry (7×13),
              Garnet (8×13), dan Mahogany (9×13).
            </div>
          </div>
          {/* <hr color="black" />
          <div className="gridspek">
            <FontAwesomeIcon icon={faMaximize} />
            <span> : 117m²</span>
            <FontAwesomeIcon icon={faHouse} />
            <span> : 133m²</span>
            <FontAwesomeIcon icon={faBed} />
            <span>: 4+1</span>
            <FontAwesomeIcon icon={faShower} />
            <span>: 3+1</span>
          </div> */}
          <div className="containerwhatsapp">
            <button onClick={mulberrywa} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
      </div>
      <div className="container-card2">
        {/* <div className="kartu">
          <Slider {...settings}>
            {vanicaimages.map((image, index) => (
              <img
                className="kartugambar"
                key={index}
                src={image}
                alt={`Astha ${index + 1}`}
              />
            ))}
          </Slider>
          <div className="container-title-card">
            <div className="titlecard">
              <div className="judul-rumah">Vanica</div>
              <div className="sub-judul-rumah">New Launch</div>
              <div className="cicilan">
                <div className="angka">9 Juta/Bulan</div>
              </div>
            </div>
          </div>
          <hr color="black" />
          <div className="gridspek">
            <FontAwesomeIcon icon={faMaximize} />
            <span> : 91m²</span>
            <FontAwesomeIcon icon={faHouse} />
            <span> : 102m²</span>
            <FontAwesomeIcon icon={faBed} />
            <span>: 3+1</span>
            <FontAwesomeIcon icon={faShower} />
            <span>: 3+1</span>
          </div>
          <div className="containerwhatsapp">
            <button onClick={vanicawa} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div> */}

        <div className="kartu">
          <Slider {...settings}>
            {Morizenimages.map((image, index) => (
              <img
                className="kartugambar"
                key={index}
                src={image}
                alt={`Astha ${index + 1}`}
              />
            ))}
          </Slider>
          <div className="container-title-card">
            <div className="titlecard">
              <div className="judul-rumah">Morizen</div>
              <div className="sub-judul-rumah">Siap Huni</div>
              {/* <div className="cicilan">
                <div className="angka">22 Juta/Bulan</div>
              </div> */}
            </div>
          </div>
          <hr color="black" />
          <div className="deskripsi-cluster">
            <div className="deskripsi">
              Morizen menawarkan tujuh tipe rumah berlantai tiga dengan luas
              tanah bervariasi: Hinoki (9×14,5 m), Keyaki (10×14,5 m), Tsuga &
              Hiiragi (10×16 m), Kaede (10×17 m), Sakura (10×18 m), Kaede
              Premium (12×16 m), dan Nara (12×18 m).
            </div>
          </div>
          {/* <hr color="black" />
          <div className="gridspek">
            <FontAwesomeIcon icon={faMaximize} />
            <span> : 160m²</span>
            <FontAwesomeIcon icon={faHouse} />
            <span> : 389m²</span>
            <FontAwesomeIcon icon={faBed} />
            <span>: 4+1</span>
            <FontAwesomeIcon icon={faShower} />
            <span>: 4+1</span>
          </div> */}
          <div className="containerwhatsapp">
            <button onClick={morizenwa} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
        <div className="kartu">
          <Slider {...settings}>
            {Burgundyimages.map((image, index) => (
              <img
                className="kartugambar"
                key={index}
                src={image}
                alt={`Astha ${index + 1}`}
              />
            ))}
          </Slider>
          <div className="container-title-card">
            <div className="titlecard">
              <div className="judul-rumah">Burgundy Residence</div>
              <div className="sub-judul-rumah">Siap Huni</div>
              {/* <div className="cicilan">
                <div className="angka">10 Juta/Bulan</div>
              </div> */}
            </div>
          </div>
          <hr color="black" />
          <div className="deskripsi-cluster">
            <div className="deskripsi">
              Burgundy Residence menyasar segmen entry-level hingga menengah
              dengan lima tipe: Carmine (5×11), Scarlet (6×11), Magenta (7×13),
              Vermilion (8×13), dan Vermilion Trendy (8×13).
            </div>
          </div>
          {/* 
          <div className="gridspek">
            <FontAwesomeIcon icon={faMaximize} />
            <span> : 118m²</span>
            <FontAwesomeIcon icon={faHouse} />
            <span> : 104m²</span>
            <FontAwesomeIcon icon={faBed} />
            <span>: 4+1</span>
            <FontAwesomeIcon icon={faShower} />
            <span>: 4</span>
          </div> */}
          <div className="containerwhatsapp">
            <button onClick={burgundywa} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
      </div>
      <div className="container-card2">
        {/* <div className="kartu">
          <Slider {...settings}>
            {jasmiaimages.map((image, index) => (
              <img
                className="kartugambar"
                key={index}
                src={image}
                alt={`Astha ${index + 1}`}
              />
            ))}
          </Slider>
          <div className="container-title-card">
            <div className="titlecard">
              <div className="judul-rumah">Jasmia</div>
              <div className="sub-judul-rumah">Siap Huni</div>
              <div className="cicilan">
                <div className="angka">12 Juta/Bulan</div>
              </div>
            </div>
          </div>
          <hr color="black" />
          <div className="gridspek">
            <FontAwesomeIcon icon={faMaximize} />
            <span> : 135m²</span>
            <FontAwesomeIcon icon={faHouse} />
            <span> : 149m² </span>
            <FontAwesomeIcon icon={faBed} />
            <span>: 3+1</span>
            <FontAwesomeIcon icon={faShower} />
            <span>: 3+1</span>
          </div>
          <div className="containerwhatsapp">
            <button onClick={jasmiawa} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default magenta;
